import { getItemStorage, setItemStorage } from 'utils/persistenceUtils'
import React, { useState, useEffect } from 'react'
import iconWarning from '../../assets/images/warning.svg'
import { TermsModalMobile } from '../Modal/indexMobile'
import * as S from './stylesMobile'

const STORAGE_KEY = 'terms'

const CookiesMobile = () => {
  const [isConsentGiven, setConsentGiven] = useState(true)
  const [isTermsModalOpen, setTermsModalOpen] = useState(false)

  useEffect(() => {
    const storageAccept = getItemStorage(STORAGE_KEY)

    if (!storageAccept) {
      setConsentGiven(false)
    }
  }, [])

  const handleConsent = () => {
    setConsentGiven(true)
    setItemStorage(STORAGE_KEY, 'true')
  }

  const handleOpenTermsModal = () => {
    setTermsModalOpen(true)
  }

  const handleCloseTermsModal = () => {
    setTermsModalOpen(false)
  }

  return isConsentGiven ? null : (
    <S.Container>
      <S.ContentBox>

      <S.Content>
        <img src={iconWarning} alt="alert" />
        <S.CookieContent>
          Seu consentimento é importante! Ao prosseguir em nosso site, você está concordando com o uso de cookies. Caso tenha dúvidas, consulte as informações disponíveis em nossa
          .
          <button type="button" onClick={handleOpenTermsModal} className="terms-link">
             Política de Cookies{' '}
          </button> .
        </S.CookieContent>
        <S.CookieButton type="button" onClick={handleConsent}>
          Aceitar
        </S.CookieButton>
      </S.Content>
        {isTermsModalOpen && <TermsModalMobile onClose={handleCloseTermsModal} />}
      </S.ContentBox>
    </S.Container>
  )
}

export default CookiesMobile
